var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('iframe',{attrs:{"id":"entreprise-frame","src":_vm.pageUrl,"sandbox":"allow-scripts allow-same-origin allow-top-navigation","allowTransparency":"true","scrolling":"no","frameborder":"0","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }